function uniqBy(arr, key) {
	const seen = new Set();

	return arr.filter((it) => {
		const val = it[key];
		if (seen.has(val)) {
			return false;
		}
		seen.add(val);
		return true;
	});
}

export default uniqBy;
